import Mixpanel from 'mixpanel-browser';

enum EventNameList {
  CallHistorySearchClicked = 'Call History Search',
  CallFiltersClicked = 'Call Filters Click',
  TeamsButtonClicked = 'Teams Button Click',
  DialerClicked = 'Dialer Click',
  DialerChangeCallerID = 'Dialer Change Caller ID',
  ChangeCountry = 'Change Country',
  ContactsClicked = 'Contacts Click',
  AddAContact = 'Add a contact',
  ContactSearchClicked = 'Contact Search',
  AccountClicked = 'Account Clicked',
  SettingsChangeCallerID = 'Settings Change Caller ID',
  ChangeLanguage = 'Change Language',
  AudioDeviceClicked = 'Audio Device',
  SoundsClicked = 'Sounds',
  GetHelpClicked = 'Get Help',
  TransferButtonClicked = 'Transfer Button',
  InCallTagClicked = 'In Call Tag',
  InCallNotesClicked = 'In Call Notes',
  ConferenceButtonClicked = 'Conference button',
  InCallKeypadClicked = 'In call keypad',
  AnnouncementButtonClicked = 'Announcement button',
  InCallAddAContactClicked = 'In call Add a contact',
  PlayCallRecording = 'Play Call recording',
  HistoryAddTagClicked = 'History: Add Tag',
  HistoryAddNoteClicked = 'History: Add Note',
  SignOutClicked = 'Sign Out',
  QueuesClicked = 'Queues Clicked',
  // Tracking the clicks on the Messages menu item
  ConversationsClicked = 'Messages Click',
  // Tracking the clicks on sending a new message button
  NewSMSClicked = 'NewSMS Click',
  // Tracking the clicks on sending a message
  SendSMSClicked = 'SendSMS Click',
}

export const eventNames = EventNameList;

/**
 * @param eventSelector
 */
const eventTracker = (
  eventSelector: (events: typeof eventNames) => keyof typeof eventNames
) => {
  Mixpanel.track(eventSelector(eventNames));
};

export default eventTracker;
